import { styles } from './template.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
export const templateGoogleWorkspaceSensor = document.createElement('template');

templateGoogleWorkspaceSensor.innerHTML = `
  <style>${styles}</style>
  <style>${styleHelpersStyles}</style>
  <div class="form-wrapper" id="integration-types" class="sensor-wrapper">
    <gz-form-field  class="sensor-select-wrapper">
       <gz-checkbox gz-form-input class="sensor-select" style="display: none" checked></gz-checkbox>
    </gz-form-field>
    <div class="sensor-data">
    
      <div class="gz-label-field" id="google_workspace_admin_label"></div>
      <div class="sensor-data-list">
        <gz-form-field label="" id="google_workspace_admin_email" required stacked>
          <gz-input gz-form-input="" type="text" inputWidth="320"></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
        
        <gz-form-field label="" id="google_workspace_domain" required stacked>
          <gz-input gz-form-input="" type="text" inputWidth="320"></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
      </div>
      
      <div class="gz-label-field" id="google_workspace_service_label"></div>
      <div class="sensor-data-list">
        <gz-form-field label="" id="google_workspace_sa_details" stacked>
          <gz-file-input gz-form-input id="google_workspace_sa_details_file" accept=".json">
            <gz-button
                  id='google_workspace_sa_details_btn_import_file'
                  browse-button
                  type='full'
                  color= 'primary'
                  buttonHeight='medium'
                  buttonFontSize='medium'
                  lowercase='true'
                >
              </gz-button>
           </gz-file-input>
           <label id="label_for_google_workspace_sa_details_file" for="google_workspace_sa_details_file"></label>
        </gz-form-field>
      </div>
      
      <div class="sensor-data-list">
        <gz-form-field label="" id="google_workspace_iss" required stacked>
          <gz-input gz-form-input="" type="text" inputWidth="400"></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
      </div>
      
      <div class="sensor-data-list">
        <gz-form-field label="" id="google_workspace_private_key" required stacked>
          <gz-input gz-form-input type="password" inputWidth="664"></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
      </div>
            
    </div>
  </div>
`;
